// src/lib/postIntent.js
const KEY = 'pendingIntent';

export function savePostIntent(input) {
  if (!input) return;
  localStorage.setItem(KEY, JSON.stringify({ input, ts: Date.now() }));
}

export function peekPostIntent() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function consumePostIntent() {
  const v = peekPostIntent();
  localStorage.removeItem(KEY);
  return v;
}
